import { memberActionType } from '../../constants/index';

const initialState = {
    membersAll: [],
    membersAPISuccess: false,
    loading: false,
    error: null
};

export default (state = initialState, action) => {
    switch (action.type) {
        case memberActionType.FETCH_MEMBERS_LOADING:
            return {
                ...state,
                loading: action.payload
            };
        case memberActionType.FETCH_MEMBERS_ALL:
            return {
                ...state,
                membersAll: action.payload,
                error: null
            };
        case memberActionType.FETCH_MEMBERS_ERROR:
            return {
                ...state,
                error: action.payload
            };
        case memberActionType.FETCH_MEMBERS_SUCCESS:
            return {
                ...state,
                membersAPISuccess: action.payload
            };
        default:
            return state;
    }
}; 